import { requestAsync } from 'redux-query';
import { STORE_KEYS } from '../constants';
import { createApiFetch } from '../actions/helpers';
import auth from 'dash-front/auth';

export const fetchTemplates = () => {
    const requestConfig = createApiFetch({
        url: `/api/templates/list?access_token=${auth.getAccessToken()}`,
        key: STORE_KEYS.TEMPLATES,
    });
    return requestAsync(requestConfig);
};

export const fetchTemplateById = id => {
    const requestConfig = createApiFetch({
        url: `/api/templates/${id}?access_token=${auth.getAccessToken()}`,
        key: STORE_KEYS.TEMPLATE_BY_ID + '.' + id,
    });
    return requestAsync(requestConfig);
};



/** WEBPACK FOOTER **
 ** ../src/dash/front/actions/templates.js
 **/